import { FieldTypes, GalleryDetailsFieldsEdit } from '../../../../types/form-types'
import LocationFieldEdit from '../../wells/location-field-edit'
import LookupField from '../../wells/lookup-field'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { TOOLTIP } from '../../../../constants/tooltips'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { FormField, TextInput } from '@msaf/core-react'

interface WellConstructionGalleryDetailsEditInterface {
  fields: Partial<GalleryDetailsFieldsEdit>
  index: number
  isLoading: boolean
  setValue: SetValue<GalleryDetailsFieldsEdit>
  validationErrors: ValidationErrors
}

export default function WellConstructionGalleryDetailsEdit({
  fields,
  index,
  isLoading,
  setValue,
  validationErrors,
}: WellConstructionGalleryDetailsEditInterface) {
  return (
    <>
      <LocationFieldEdit
        isLoading={isLoading}
        formFieldLabel='Start coordinates'
        labelledBy='galleryStartCoordinates'
        easting={{
          fieldId: 'galleryStartEasting',
          value: `${fields.galleryStartEasting ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryStartEasting', value),
        }}
        northing={{
          fieldId: 'galleryStartNorthing',
          value: `${fields.galleryStartNorthing ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryStartNorthing', value),
        }}
        latitude={{
          fieldId: 'galleryStartLatitude',
          value: `${fields.galleryStartLatitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryStartLatitude', value),
        }}
        longitude={{
          fieldId: 'galleryStartLongitude',
          value: `${fields.galleryStartLongitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryStartLongitude', value),
        }}
        index={index}
        validationFieldErrors={validationErrors}
      />
      <LocationFieldEdit
        index={index}
        isLoading={isLoading}
        formFieldLabel='End coordinates'
        labelledBy='galleryEndCoordinates'
        easting={{
          fieldId: 'galleryEndEasting',
          value: `${fields.galleryEndEasting ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryEndEasting', value),
        }}
        northing={{
          fieldId: 'galleryEndNorthing',
          value: `${fields.galleryEndNorthing ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryEndNorthing', value),
        }}
        latitude={{
          fieldId: 'galleryEndLatitude',
          value: `${fields.galleryEndLatitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryEndLatitude', value),
        }}
        longitude={{
          fieldId: 'galleryEndLongitude',
          value: `${fields.galleryEndLongitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('galleryEndLongitude', value),
        }}
        validationFieldErrors={validationErrors}
      />
      <FormField
        toolTipMessage={TOOLTIP.galleryDepth}
        validationMessages={validationErrors?.galleryDepth}
        isSkeleton={isLoading}
        label='Gallery depth (m)'
        htmlFor='galleryDepth'
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='galleryDepth'
          value={`${fields.galleryDepth ?? ''}`}
          describedBy='gallery-details-group'
          setValue={(value) => setValue('galleryDepth', value)}
          isInvalid={!!validationErrors?.galleryDepth}
        />
      </FormField>
      <FormField
        validationMessages={validationErrors?.galleryLength}
        isSkeleton={isLoading}
        label='Gallery length (m)'
        htmlFor='galleryLength'
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='galleryLength'
          value={`${fields.galleryLength ?? ''}`}
          describedBy='gallery-details-group'
          setValue={(value) => setValue('galleryLength', value)}
          isInvalid={!!validationErrors?.galleryLength}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.galleryWidth}
        validationMessages={validationErrors?.galleryWidth}
        isSkeleton={isLoading}
        label='Gallery width (mm)'
        htmlFor='galleryWidth'
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='galleryWidth'
          value={`${fields.galleryWidth ?? ''}`}
          describedBy='gallery-details-group'
          setValue={(value) => setValue('galleryWidth', value)}
          isInvalid={!!validationErrors?.galleryWidth}
        />
      </FormField>
      <FormField
        toolTipMessage={TOOLTIP.galleryDirectionId}
        validationMessages={validationErrors?.galleryDirection}
        isSkeleton={isLoading}
        label='Gallery direction'
        htmlFor='galleryDirection'
      >
        <LookupField
          labelledBy='galleryDirection'
          isSkeleton={isLoading}
          fieldId='galleryDirection'
          value={`${fields.galleryDirection ?? ''}`}
          setValue={({ value }) => setValue('galleryDirection', value)}
        />
      </FormField>
      <FormField
        validationMessages={validationErrors?.casingMaterial}
        isSkeleton={isLoading}
        label='Casing type'
        htmlFor='casingMaterial'
      >
        <LookupField
          labelledBy='casingMaterial'
          isSkeleton={isLoading}
          fieldId='casingMaterial'
          value={`${fields.casingMaterial ?? ''}`}
          setValue={({ value }) => setValue('casingMaterial', value)}
        />
      </FormField>
    </>
  )
}
